import React, { useState, useEffect } from "react";
import "./Project.css";
import { HiArrowRight, HiExternalLink, HiLockClosed } from "react-icons/hi";
import { NavLink } from "react-router-dom";
import useScrollReveal from "../../hooks/useScrollReveal";
import projects from "./projectsData";

const categories = ["All", "Full-Stack", "AI / Voice", "Cloud / DevOps", "Frontend"];

const Project = () => {
  const [activeCategory, setActiveCategory] = useState("All");
  const gridRef = useScrollReveal({ staggerChildren: true, staggerDelay: 100 });

  const filteredProjects = activeCategory === "All"
    ? projects
    : projects.filter(p => p.type === activeCategory);

  useEffect(() => {
    if (gridRef.current) {
      const children = gridRef.current.querySelectorAll(".reveal-child");
      children.forEach((child, i) => {
        setTimeout(() => {
          child.classList.add("revealed");
        }, i * 60);
      });
    }
  }, [activeCategory, gridRef]);

  return (
    <section className="portfolio" id="projects">
      <h2 className="section-title">
        Featured <span>Projects</span>
      </h2>

      {/* Category Filter Tabs */}
      <div className="project-categories">
        {categories.map((cat) => (
          <button
            key={cat}
            className={`project-cat-tab ${activeCategory === cat ? "active" : ""}`}
            onClick={() => setActiveCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="projects-grid" ref={gridRef}>
        {filteredProjects.map((project) => (
          <div className="project-card reveal-child" key={project.id}>
            <div className="project-img-wrap">
              <img src={project.img} alt={project.title} />
              <div className="project-img-overlay" />
              <span className="project-type-badge">{project.type}</span>
              {/* Client project lock badge on image */}
              {project.isClientProject && (
                <span className="project-client-badge">
                  <HiLockClosed /> Client Project
                </span>
              )}
            </div>

            <div className="project-body">
              <h3 className="project-title">{project.title}</h3>
              <p className="project-desc">{project.shortDesc}</p>

              <div className="project-tags">
                {project.tags.slice(0, 4).map((tag) => (
                  <span className="project-tag" key={tag}>{tag}</span>
                ))}
                {project.tags.length > 4 && (
                  <span className="project-tag project-tag-more">
                    +{project.tags.length - 4}
                  </span>
                )}
              </div>

              <div className="project-footer">
                {project.isClientProject ? (
                  /* Client project — no links, show NDA notice */
                  <span className="project-private-note">
                    <HiLockClosed />
                    Source & demo restricted (NDA)
                  </span>
                ) : (
                  /* Public project — show live demo link */
                  <a
                    href={project.liveLink}
                    target="_blank"
                    rel="noreferrer"
                    className="project-link"
                  >
                    <HiExternalLink />
                    Live Demo
                  </a>
                )}

                {/* View Details always available */}
                <NavLink
                  to={`/project/${project.id}`}
                  className="project-link project-link-detail"
                >
                  View Details
                  <HiArrowRight />
                </NavLink>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Project;
